import { Content } from './Content';import { Footer } from '../../components/Footer';
import { Header } from './Header';
import './home.scss';
const slide = {
  imgSrc: '/image/screen1.png',
  title: '秒速开盒，即刻揭晓',
  text: '极简操作流程无需等待，一键抽盒，瞬时解锁时尚数码好物 ',
  width: '40rem',
  height: '45.31rem',
};
export function Cooperation() {
  return (
    <div className='main'>

      <Header />
      <div className='wrapper' style={{
        transform: `translate3d(0px, ${-0}px, 0px)`,
        transitionDuration: '0.8s',
        transitionDelay: '0ms',
      }}>

        <div className="page" style={{ backgroundImage: `url(/image/background.png)` }}>
          <div className="wrap" style={{ ['--cover-width' as any]: slide.width, ['--cover-height' as any]: slide.height }}>

            <Content title={slide.title} text={slide.text} />
            <div className='component-describe'>
              <div className='component-describe-title'>商业合作</div>
              <div className='component-describe-value'>
                <div className='value-line'>怀远模玩文化有限公司依托成熟的潮流文创运营体系、丰富的产品资源与庞大的年轻消费用户群体，面向全行业开放多元商业合作渠道，诚邀各大IP方、品牌方、供应链厂商、渠道经销商、线上线下零售伙伴携手共赢，深耕潮流文创、手办潮玩、轻奢消费赛道，共建潮流消费新生态。</div>
                <div className='value-line'>公司目前已形成手办、潮鞋、奢侈品、盲盒四大成熟业务体系，拥有稳定的货源渠道、完善的品控体系和高效的运营能力，凭借正品保障、极速物流、贴心客服的核心优势，在行业内树立了良好的品牌信誉。我们可提供灵活多样的合作模式，包括品牌联名合作、IP产品授权、货源供应链对接、渠道分销合作、盲盒玩法定制、新零售运营合作等，全方位适配不同合作伙伴的发展需求。</div>
                全方位扶持。合作方可共享公司流量资源、用户体系与运营经验，依托公司成熟的销售渠道与服务体系，快速拓展市场、提升产品销量与品牌影响力。同时，公司可根据合作需求，定制专属产品方案与运营策略，严控产品品质，保障合作双方权益。未来，我们期待与各界优质合作伙伴深度联动，整合行业资源、创新潮流业态，共同挖掘潮流文创市场新机遇，实现互利共赢、长远发展。 </div>
            </div>
          </div>
        </div>   </div>
            {/* 底部 */}
                <Footer />
    </div>
  );
}
